import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { TabNames } from '@enums/TabNames';
import { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-enterprise';

export const BUILDING_COMPANIES_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'companyId',
        field: 'companyId',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/companies-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'companyName',
        field: 'companyName',
        headerName: 'Name',
        cellDataType: 'text'
    },
    {
        colId: 'contactFullName',
        field: 'contactFullName',
        headerName: 'Main Contact',
        cellDataType: 'text'
    },
    {
        colId: 'line2',
        field: 'line2',
        headerName: 'Address line 2',
        cellDataType: 'text',
        sortable: false
    },
    {
        colId: 'companyTypeName',
        field: 'companyTypeName',
        headerName: 'Type',
        cellDataType: 'text'
    },
    {
        colId: 'companyMarkets',
        field: 'companyMarkets',
        headerName: 'Markets',
        cellDataType: 'text',
        valueFormatter: (params: ValueFormatterParams) => {
            if (Array.isArray(params.value)) {
                return params.value.filter(Boolean).join(', ');
            }
            return params.value || '';
        }
    },
    {
        colId: 'isMain',
        field: 'isMain',
        headerName: 'Main Office',
        width: 150,
        sortable: false,
        filter: false,
        suppressHeaderMenuButton: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                return '<span class="badgeMain primaryColor">Main Office</span>';
            }
            return '';
        }
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell'
    }
];
